export default __webpack_public_path__ + "static/media/gallery-wip-grenade_06.32c42e60.jpg";